import { FC } from 'react'
import { DraftData, DraftDistribution, DraftDistributionType } from './types/types'
import WebsiteDistribution from './DistributionTypes/WebsiteDistribution'
import SecretDistribution from './DistributionTypes/SecretDistribution'
import GpsDistribution from './DistributionTypes/GpsDistribution'
import CodesDistribution from './DistributionTypes/CodesDistribution'
import ExpressDistribution from './DistributionTypes/ExpressDistribution'

interface DistributionInfoProps {
  distribution: DraftDistribution
  draftData: DraftData
}

const DistributionInfo: FC<DistributionInfoProps> = ({ distribution, draftData }) => {
  switch (distribution.type) {
    case DraftDistributionType.WEBSITE:
      return <WebsiteDistribution website={distribution.website} />
    case DraftDistributionType.SECRET:
      return <SecretDistribution secret={distribution.secret} />
    case DraftDistributionType.GPS:
      return <GpsDistribution gps={distribution.gps} />
    case DraftDistributionType.CODES:
      return <CodesDistribution draftData={draftData} />
    case DraftDistributionType.EXPRESS:
      return <ExpressDistribution express={distribution.express} />
  }
}

export default DistributionInfo
